import { getClassNames, ROUTES } from '@ab-core/functions';
import type { ImageProps } from '@ab-core/image';
import { Image } from '@ab-core/image';
import { Link, LINK_VARIANT } from '@ab-core/link';
import type { FC } from 'react';
import React from 'react';
import type { ScalableStyle } from '../../scalableStyles';
import { StyledImageContainer } from './styled';

export type ImageContainerStyleType = ScalableStyle<{
    isVisible?: boolean;
}>;

export type ImageContainerProps = {
    imgSrc?: ImageProps['src'];
    link?: string;
    sku?: string;
    position?: number;
    isSmartphone?: boolean;
    mainId?: string;
};

export const ImageContainer: FC<ImageContainerProps & ImageContainerStyleType> = (props) => {
    const {
        imgSrc,
        sku,
        link = `${ROUTES.PRODUCTPAGE}/${sku}`,
        position,
        scalableStyle,
        isSmartphone = false,
        mainId
    } = props;

    const mobileClassView = getClassNames({
        prefix: 'scalable-product-card',
        modifier: { isSmartphone }
    });

    if (!scalableStyle?.isVisible) {
        return <></>;
    }

    return (
        <StyledImageContainer className={mobileClassView}>
            <Link
                to={link}
                variant={LINK_VARIANT.LINK_ONLY}
                state={{ previousUrl: window.location.search, position, mainId }}
            >
                <Image src={imgSrc} />
            </Link>
        </StyledImageContainer>
    );
};
